import {
    PhoneDetails, ProviderDisplayDocumentType,
    ProviderPhone
} from '@enter/core';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { RootStore } from 'stores';
import * as S from './claim-timeline-table.styles';

interface IPhoneDetailProps {
    phone: ProviderPhone;
}

export const PhoneDetail: React.FunctionComponent<IPhoneDetailProps> = inject('rootStore')(
    observer(
        (props: IPhoneDetailProps): React.ReactElement => {
            const rootStore: RootStore = _.get(props, 'rootStore');
            if (!rootStore) {
                return <></>;
            }
            const {phone} = props;
            const { claimStore } = rootStore;

            const downloadDocumentUrlBinding = claimStore.loadDocumentDownloadUrl.bind(claimStore);
            const transcribeUrlBinding =  claimStore.getDocumentTranscript.bind(claimStore);

            return (
                <S.ExpandContainer>
                    <S.ExpandTable>
                        <S.ExpandTBody>
                            <S.ExpandTR>
                                <S.ExpandTH>ID</S.ExpandTH>
                                <S.ExpandTD>{phone.id}</S.ExpandTD>
                            </S.ExpandTR>
                            <S.ExpandTR>
                                <S.ExpandTH>Type</S.ExpandTH>
                                <S.ExpandTD>{phone.method}</S.ExpandTD>
                            </S.ExpandTR>
                            <S.ExpandTR>
                                <S.ExpandTH>Enter Representative</S.ExpandTH>
                                <S.ExpandTD>{phone.agent}</S.ExpandTD>
                            </S.ExpandTR>
                        </S.ExpandTBody>
                    </S.ExpandTable>
                    <PhoneDetails phone={phone} downloadDocument={downloadDocumentUrlBinding} transcribeDocument={transcribeUrlBinding}/>
                </S.ExpandContainer>
            );
        },
    ),
);
